/**
 * Created by shegj on 2018-04-03.
 * 网络请求工具 RequestUtil
 */

"use strict";
import getUrl from './UrlUtil';
import Constants from '../common/Constants';
import {Message} from 'iview';
/**
 * 普通网络请求
 * @param url
 * @param formData
 * @returns {Promise<string>}
 */
const request = (url, formData) => {
  let headersObj = {
    'Content-Type': 'application/x-www-form-urlencoded'
  };
  let data = "";
  if(formData){
    if(typeof formData === 'object'){
      // headersObj = {
      //   'Accept': 'application/jsonp',
      //   'Content-Type': 'application/jsonp;charset=utf-8'
      // };
      data = JSON.stringify(formData);
    }
  }
  return fetch(getUrl(url), {
    method: 'POST',
    headers: headersObj,
    credentials: 'include',   //dev模式解决跨域问题
    body: "dataInfo=" + data
  }).then((response) => response.text())
    .then((responseText) => {
      if(responseText){
        const json = JSON.parse(responseText);
        if(Constants.statusCode.timeout == json.statusCode){
          localStorage.removeItem("userInfo");
          window.location = "";
        }else if (Constants.statusCode.ok != json.statusCode) {
          if(json.message){
            Message.error({content:json.message,duration: 5});
          }
        }
        return json;
      }
      return null;
    }).catch((error) => {
      Message.error("网络请求错误，请检查网络！");
    });
};

const requestJson = (url) => {
  let headersObj = {
    'Content-Type': 'application/x-www-form-urlencoded'
  };
  return fetch(url, {
    method: 'POST',
    headers: headersObj,
    credentials: 'include'   //dev模式解决跨域问题
  }).then((response) => {
      if(response){
        return response.text();
      }
      return null;
    }).catch((error) => {
      Message.error("网络请求错误，请检查网络！");
    });
};

/**
 * 带回调的网络请求
 * @param url
 * @param formData
 * @returns {Promise<any>}
 */
const requestPromise = (url, formData) => {
  let isOk;
  let headersObj = {
    'Content-Type': 'application/x-www-form-urlencoded',
  };
  if(formData){
    if(typeof formData === 'object'){
      headersObj = {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8'
      };
    }
  }
  return new Promise((resolve, reject) => {
    fetch(getUrl(url), {
      method: 'POST',
      headers: headersObj,
      credentials: 'include',   //dev模式解决跨域问题
      body: formData
    }).then((response) => response.text())
      .then((responseText) => {
        if(responseText){
          const json = JSON.parse(responseText);
          if (Constants.statusCode.ok == json.statusCode) {
            isOk = true;
          } else {
            isOk = false;
          }
          return json;
        }else{
          isOk = false;
        }
        return null;
      })
      .then((responseData) => {
        if (isOk) {
          resolve(responseData);
        } else {
          reject(responseData);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export default {
  request,
  requestJson,
  requestPromise,
};



// WEBPACK FOOTER //
// ./src/utils/RequestUtil.js